import React from 'react';
import PropTypes from 'prop-types';
import { FlexBox, Span } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { useLineItemData } from '../contexts/LineItemDataProvider';
import { ItemStatusTooltip } from './ItemStatusTooltip';
import { useCustomerFeedbackGroup } from '../contexts/CustomerFeedbackGroupsProvider';

import { FeedbackType } from '../../types/feedback/Feedback';
import { FeedbackGroupState } from '../../types/feedback/FeedbackGroup';

const LineItemStatus = ({ statuses }) => {
  const [orderStatuses] = useTranslations(['orderStatuses']);
  const { id: lineItemId } = useLineItemData();

  const { customerFeedbackGroupExists: designFeedbackRequestExists } =
    useCustomerFeedbackGroup({
      lineItemId,
      requestType: FeedbackType.DOCUMENT_REVIEW,
      groupState: FeedbackGroupState.AWAITING_FEEDBACK,
    });

  // If design feedback group in pending exists for the lineItem we override the status to be `pendingCustomerFeedback` and ignore the `disableItemStatus` parameter
  if (designFeedbackRequestExists) {
    return (
      <Span fontWeight="bold" mr={3} textColor="error">
        {orderStatuses.pendingCustomerFeedback}
      </Span>
    );
  }

  return (
    <>
      {statuses.map(
        ({ statusTranslationKey, color, quantity = null, detail }, index) => {
          const additionalProps = {};
          if (color === 'alert' || color === 'error') {
            additionalProps.color = color;
          } else if (color === 'pending') {
            additionalProps.color = 'grey-700';
          } else if (color === 'success') {
            // This is the green color from Visage badge that meets contrast a11y criteria
            additionalProps.style = { color: '#0a856a' };
          }
          const { color: textColor, style } = additionalProps;

          return (
            <FlexBox key={index}>
              <Span fontWeight="bold" textColor={textColor} style={style}>
                {orderStatuses[statusTranslationKey]}{' '}
                {quantity ? `x(${quantity})` : ''}
              </Span>
              {detail ? <ItemStatusTooltip detail={detail} /> : null}
              <Span>{statuses.length - 1 === index ? '' : ', '}</Span>
            </FlexBox>
          );
        }
      )}
    </>
  );
};

LineItemStatus.propTypes = {
  statuses: PropTypes.array,
};

export default LineItemStatus;
